/**
 * 项目token设置
 * */
import {getProjectCode} from "./code";

const TokenKey = 'platform_token'

// 获取
export function getToken() {
  let token = window.localStorage.getItem(TokenKey)
  return token ? token : getRandom()+';'+getProjectCode()+';01';
}

// 设置
export function setToken(token) {
  window.localStorage.setItem(TokenKey, token)
}

// 删除
export function removeToken() {
  window.localStorage.removeItem(TokenKey)
}

// 删除
export function removeAll() {
  window.localStorage.clear()
}

function getRandom(){
  let str_nums= "",
    range = 32,
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  for (let i = 0; i < range; i++) {
    let id = Math.round(Math.random() * (arr.length - 1));
    str_nums+= arr[id];
  }
  return str_nums;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js